var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOffset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.87988 19.5H1.87988V22H3.87988V19.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.87988 13.38H1.87988V17.76H3.87988V13.38Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.87988 7.25H1.87988V11.63H3.87988V7.25Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.87988 5.5H3.87988V4H5.37988V2H1.87988V5.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5599 2H7.14988V4H11.5599V2Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7399 2H13.3299V4H17.7399V2Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9999 2H19.4999V4H21.9999V2Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 18.58L13.4099 12H11.9999V13.41L18.5799 20L16.7499 19.99V22L21.9899 21.99L21.9999 16.75H19.9899L19.9999 18.58Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99988 22H9.99988V10H21.9999V8H7.99988V22Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOffset);
export default __webpack_public_path__ + "static/media/icon-offset.f457f52b2b3697edfbccad35da6dd91a.svg";
export { ForwardRef as ReactComponent };